import { Button } from '@spotted-zebra-uk/ui-components';
import styles from './SkillDrawerButtons.module.scss';

type SkillDrawerButtonsProps = {
  isEditMode: boolean;
  onArchive: () => void;
  onArchiveLoading: boolean;
  isArchived: boolean;
  onEdit: () => void;
  onSave: () => void;
  onSaveLoading: boolean;
  onCancel: () => void;
};

const SkillDrawerButtons = ({
  isEditMode,
  onArchive,
  onArchiveLoading,
  isArchived,
  onSave,
  onCancel,
  onEdit,
  onSaveLoading,
}: SkillDrawerButtonsProps) => {
  return (
    <div className={styles.buttonContainer}>
      {!isEditMode ? (
        <>
          <Button
            className={styles.button}
            onClick={onArchive}
            variant="secondary"
            size="large"
            loading={onArchiveLoading}
          >
            {isArchived ? 'Unarchive' : 'Archive'}
          </Button>
          <Button
            className={styles.button}
            variant="primary"
            size="large"
            onClick={onEdit}
          >
            Edit
          </Button>
        </>
      ) : (
        <>
          <Button
            className={styles.button}
            onClick={onCancel}
            variant="secondary"
            size="large"
          >
            Cancel
          </Button>
          <Button
            className={styles.button}
            onClick={onSave}
            variant="primary"
            size="large"
            loading={onSaveLoading}
          >
            Save
          </Button>
        </>
      )}
    </div>
  );
};

export default SkillDrawerButtons;
